import EXERCISES_UI_ACTION from '../../constants/action'
import EXERCISES_PATH from '../../constants/path'
import setReduxAction from '../../../redux/actions/set'

export function updateTypeFilterExercisesAction (values) {
  return (dispatch) => {
    dispatch(setReduxAction({
      type: EXERCISES_UI_ACTION.UPDATE_TYPE_FILTER,
      payload: {
        path: EXERCISES_PATH.TYPE_FILTER,
        value: values
      }
    }))
  }
}
